export default __webpack_public_path__ + "0773d295ac7219411bb28a988ab0a167.ttf";